import { useNavigation } from "@react-navigation/native";
import { LinearGradient } from "expo-linear-gradient";
import React, { useEffect, useState } from 'react';
import { Text, TextInput, TouchableOpacity, View } from 'react-native';
import { Button, RadioButton } from 'react-native-paper';
import InputDefault from "../../components/Form/InputDefault";
import HeaderDefault from '../../components/HeaderDefault';
import { maskCPFCNPJ } from "../../utils/masks";
import styles from './styles';

const TransferFindUser = (props) => {
    
    const navigation = useNavigation();

    const [infoToFind, setInfoToFind] = useState('');
    const [email, setEmail] = useState('');
    const [cpfCnpj, setCpfCnpj] = useState('');

    return (
        <View>
            <HeaderDefault title={"Buscar usuário"} />

            <View style={styles.content}>


                <View>
                    <Text style={{ paddingTop: 15, paddingBottom: 15, fontWeight: '700', textAlign: 'center', fontSize: 16 }}>Como deseja buscar pelo usuário?</Text>

                    <View style={{ display: 'flex', flexDirection: 'row' }}>
                        <RadioButton
                            value="email"
                            status={infoToFind === 'email' ? 'checked' : 'unchecked'}
                            onPress={() => setInfoToFind('email')}
                        />
                        <Text style={{ paddingTop: 10 }}>Buscar por e-mail</Text>
                    </View>
                    {
                        infoToFind === 'email' &&
                        <View style={{ marginBottom: 15, paddingHorizontal: 15 }}>
                            <TextInput
                                style={{
                                    paddingHorizontal: 15,
                                    backgroundColor: "transparent",
                                    textAlign: 'left',
                                    borderBottomColor: '#999999',
                                    borderBottomWidth: 1,
                                    minHeight: 50
                                }}
                                placeholder="Digite o e-mail"
                                value={email}
                                onChangeText={(text) => { setEmail(text) }}
                            />
                        </View>
                    }
                    <View style={{ display: 'flex', flexDirection: 'row' }}>
                        <RadioButton
                            value="cpfcnpj"
                            status={infoToFind === 'cpfcnpj' ? 'checked' : 'unchecked'}
                            onPress={() => setInfoToFind('cpfcnpj')}
                        />
                        <Text style={{ paddingTop: 10 }}>Buscar por CPF/CNPJ</Text>
                    </View>
                    {
                        infoToFind === 'cpfcnpj' &&
                        <View style={{ marginBottom: 15, paddingHorizontal: 15 }}>
                            <TextInput
                                style={{
                                    paddingHorizontal: 15,
                                    backgroundColor: "transparent",
                                    textAlign: 'left',
                                    borderBottomColor: '#999999',
                                    borderBottomWidth: 1,
                                    minHeight: 50,
                                    color: 'black'
                                }}
                                keyboardType="numeric"
                                placeholder="Digite o CPF/CNPJ"
                                value={cpfCnpj}
                                onChangeText={(text) => { setCpfCnpj(maskCPFCNPJ(text)) }}
                            />
                        </View>
                    }

                </View>
            </View>
            {
                email.length === 0 && cpfCnpj.length === 0 ?
                    <Button text={"SELECIONE UM DESTINATÁRIO"} />
                    :
                    <View style={styles.contentBtn}>
                        <TouchableOpacity onPress={() => navigation.navigate({
                            name: 'ConfirmTransfer', params: {
                                token: props.route.params.token,
                                qtd: props.route.params.qtd,
                                findUserBy: infoToFind,
                                userKey: (infoToFind === 'email' ? email.toLowerCase() : cpfCnpj)
                            }
                        })}>
                            <LinearGradient
                                start={{ x: -1, y: 0 }}
                                end={{ x: 1, y: 0 }}
                                colors={["#16195B", "#1FBFB5"]}
                                style={styles.btn}
                            >
                                <Text style={styles.textBtn}>CONTINUAR</Text>
                            </LinearGradient>
                        </TouchableOpacity>
                    </View>
            }
        </View>
    );
}

export default TransferFindUser;